import debounce from 'lodash-es/debounce';

export default {
  created() {
    window.addEventListener('resize', debounce(this.onResize, 100), { passive: true });
  },
  mounted() {
    this.onResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', debounce(this.onResize, 100), { passive: true });
  },
  methods: {
    onResize() {
      // update $breakpoint values
      this.$breakpoint.update();
    },
  },
};
